export default __webpack_public_path__ + "EVChargersSelectedPin.png";